export default __webpack_public_path__ + "static/media/BeforeMeal.f2c6fa9f.svg";